import { mapGetters, mapState } from 'vuex'

import { LOCAL_STORAGE_ID } from '@/utils/relatorioFaturamento'

export const computed = {
  ...mapState('auth', ['empresaAtual']),
  ...mapState('fornecedores', ['fornecedores']),
  ...mapState('clientes', ['clientes']),
  ...mapState('transportadoras', ['transportadoras']),
  ...mapGetters('contratos', ['terminais']),
  ...mapState('patio', ['regioes', 'representantes']),
  ...mapState('motoristas', ['motoristas']),

  showDataMovimentacao() {
    return this.params.data_inicio.visible || this.params.data_fim.visible
  },
  showDataTriagem() {
    return (
      this.params.data_inicio_triagem.visible ||
      this.params.data_fim_triagem.visible
    )
  },
  showFornecedor() {
    return this.params.fornecedor.visible
  },
  showContratos() {
    return (
      (this.params.terminal.visible ||
        this.params.servico.visible ||
        this.params.cliente.visible ||
        this.params.transportadora.visible) &&
      !this.isTransportadora
    )
  },
  showRegiao() {
    return (
      (this.params.regiao.visible || this.params.representante.visible) &&
      !this.isTransportadora
    )
  },
  showVeiculo() {
    return (
      this.params.motorista.visible ||
      this.params.placa_cavalo.visible ||
      this.params.eixo.visible
    )
  },
  areSettingsEmpty() {
    return !(
      this.showDataMovimentacao ||
      this.showDataTriagem ||
      this.showFornecedor ||
      this.showContratos ||
      this.showRegiao ||
      this.showVeiculo
    )
  },
  selectedOptions() {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_ID)) || []
  },
}
